export default __webpack_public_path__ + "static/media/ev-plus.404cfb99.png";